exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top-screen[data-v-5a75fad6] {\n  top: 38px;\n}\n.left-screen[data-v-5a75fad6] {\n  left: 14px;\n}\n.img[data-v-5a75fad6] {\n  width: 40px;\n  height: 100%;\n}\n.bottom-border[data-v-5a75fad6] {\n  border-bottom: 1px solid rgba(169, 180, 188, 0.1);\n}\n.none[data-v-5a75fad6] {\n  display: none;\n}\n.grpImage[data-v-5a75fad6] {\n  width: 200px;\n  height: 100%;\n}\n.min-w7[data-v-5a75fad6] {\n  min-width: 60rem !important;\n}\n.custom-height[data-v-5a75fad6] {\n  max-height: 320px;\n  overflow-x: hidden;\n}\n", ""]);

// exports
